import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 14h8v7l8 -11h-8v-7z","key":"svg-0"}]]

const IconBrandSupabase = createReactComponent('outline', 'brand-supabase', 'BrandSupabase', __iconNode);

export default IconBrandSupabase;